export const TICKETS_STATUS = [
    { name: 'All Tickets', label: 'All Tickets', value: 'all' },
    { name: 'Unread Tickets', label: 'Unread Tickets', value: 'unread' },
    { name: 'Read Tickets', label: 'Read Tickets', value: 'read' },
]